var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../assets/images/pc/logo.png"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }